(ns ui.icons
  (:require
   [reagent.core :as r]
   ["lucide-react" :refer [Calendar EllipsisVertical PanelLeftIcon]]))

(def adapt r/adapt-react-class)

(def calendar-icon (adapt Calendar))

(def ellipsis-vertical-icon (adapt EllipsisVertical))

(def panel-left-icon (adapt PanelLeftIcon))
